<div class="container text-center text-white py-4">
  <div class="mb-3">Besoin d'assistance ?</div>

  <div class="text-center">
    <a
      class="text-white text-decoration-none d-inline-flex align-items-center gap-2"
      href="mailto:applications.chantiers@leongrosse.fr"
      target="_blank"
    >
      <i class="bi bi-envelope-fill"></i>
      <span>applications.chantiers&#64;leongrosse.fr</span>
    </a>
  </div>


  <div class="container text-center">
    <div class="row justify-content-center">
      <div class="col-auto">
        <img
          [src]="logoUrl"
          alt="Logo"
          class="img-fluid footer-logo"
          style="max-height: 100px;"
        />
      </div>
    </div>


    <div class="row">
      <div class="d-flex justify-content-center py-4 text-color-neutral">
        Heures Insertion / Version Front {{ version }}  / Version Back {{ backendVersion }}
      </div>
    </div>
  </div>
</div>
